import { render, staticRenderFns } from "./edit-email-dialog.vue?vue&type=template&id=2889d7ac&scoped=true&"
import script from "./edit-email-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-email-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2889d7ac",
  null
  
)

export default component.exports